import React from 'react'
import AboutSectionImage from "../assets/TAXI(1).png"

const AboutComponent = () => {
  return (
    <div>
      <div className="bg-neutral-100 lg:py-8 py-8 ">
        <div className="grid lg:grid-cols-2 gap-5">
            <div className="order-1 lg:order-1 items-center justify-items-center">
                <img className="h-80 w-96 object-contain lg:w-[500px] lg:h-[500px] rounded-3xl" src={AboutSectionImage} alt="AboutImage" />
            </div>
            <div className="order-2 lg:order-1 m-8 ">
            <p className="text-3xl mx-8 font-bold md:text-3xl lg:text-4xl">About us</p>
            <p className="mt-2 mx-8 text-lg md:text-lg text-justify w-10/12 pt-4 ">Welcome to <strong>OZ Wide Cover</strong>, a newly established commercial car insurance provider dedicated to serving businesses with tailored coverage solutions. We understand the unique challenges that businesses face when it comes to insuring their vehicles. Our mission is to provide comprehensive, affordable, and flexible insurance options that meet the diverse needs of our clients.</p>
            {/* <button className="text-lg md:text-2xl bg-black text-white py-2 px-5 mt-10 hover:bg-zinc-800">Read more</button> */}
            <p className="mt-2 mx-8 text-lg md:text-lg text-justify w-10/12 pt-4 ">We specialize in providing comprehensive insurance coverage for taxi and rideshare vehicles, ensuring that drivers are protected against the unique risks associated with transporting passengers for hire.</p>
            </div>
            </div>
    </div>
    </div>
  )
}

export default AboutComponent
